
// export const myMutation = ( state ) => {

// }
export const setPeriod = ( state, period ) => {
    state.period = period
}

export const setCurrentPeriod = ( state, currentPeriod ) => {
    state.currentPeriod = currentPeriod
}

export const activePeriod = ( state, period ) => {
    state.period.filter(c => c.id == period.id)[0].estado = 'Activo'
}

export const deactivatePeriod = ( state, period ) => {
    state.period.filter(c => c.id == period.id)[0].estado = 'Inactivo'
}

export const setWeeks = ( state, weeks ) => {
    const weeksList = []
    weeks.forEach(week => {
        weeksList.push({
            name: week.nombre,
            initialDate: week.fechaInicial == null ? null : new Date(week.fechaInicial),
            finalDate: week.fechaFinal == null ? null : new Date(week.fechaFinal),
            id: week.id,
            edit: false,
            period: week.periodo
        })
    });
    state.weeks = weeksList
}

export const editWeek = ( state, week ) => {
    state.weeks.filter(w => w.id == week.id)[0].edit = false
    state.weeks.filter(w => w.id == week.id)[0] = {
        initialDate: week.fechaInicial == null ? null : new Date(week.fechaInicial),
        finalDate: week.fechaFinal == null ? null : new Date(week.fechaFinal),
        name: week.nombre,
        id: week.id,
    }
} 

export const openEdit = ( state, id ) => {
    state.weeks.filter(week => week.id == id)[0].edit = true
}

export const closeEdit = ( state, { id, form } ) => {
    state.weeks.filter(week => week.id == id)[0].edit = false
    state.weeks.filter(week => week.id == id)[0].name = form.name
    state.weeks.filter(week => week.id == id)[0].initialDate = form.initialDate
    state.weeks.filter(week => week.id == id)[0].finalDate = form.finalDate
}